<template>
  <div class="list">
    <template v-for="item in list" :key="item.label">
      <div v-if="item.list.length" class="list__item">
        <h3 class="list__title">{{ item.label }}</h3>
        <div class="list__badges">
          <template v-for="(contact, index) in item.list" :key="contact?.data?.id ?? index">
            <BadgeComponent v-if="contact?.label" :text="contact?.label" icon="" />
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import BadgeComponent from "@/components/utils/badge/BadgeComponent.vue";

export default {
  name: "TrainingContactBlockListComponent",
  components: { BadgeComponent },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__title {
    font-size: 15px;
    margin-bottom: 10px;
    font-weight: 400;
  }
  &__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>
